const translations = {
    contactNameFieldLabel: 'Contact Name'
};

export default translations;
